import { MetaContextProps } from '@Components/Meta/Context';
import {
  AdvertFragment,
  AuctionFragment,
  ForumInfoFragmentFragment,
  ForumThreadFragment,
} from '@Graphql/graphqlTypes.generated';
import PlaceholderImage from '@Images/placeholder.png';
import {
  buildFullAdvertUrl,
  buildFullAuctionUrl,
  buildFullForumThreadListUrl,
  buildFullForumThreadUrl,
} from '@Utils/url';

export const buildAdvertMeta = (advert: AdvertFragment): MetaContextProps => {
  const { title, description, mainImage } = advert;
  const advertImageUrl = mainImage || PlaceholderImage;

  return {
    title,
    description,
    image: advertImageUrl,
    url: buildFullAdvertUrl(advert),
    type: MetaType.productItem,
  };
};

export const buildAuctionMeta = (auction: AuctionFragment): MetaContextProps => {
  const { title, description, mainImage } = auction;
  const advertImageUrl = mainImage || PlaceholderImage;

  return {
    title,
    description,
    image: advertImageUrl,
    url: buildFullAuctionUrl(auction),
    type: MetaType.auctionItem,
  };
};

export const buildForumMeta = (forum: ForumInfoFragmentFragment) => {
  return {
    title: forum.title,
    description: forum.description,
    url: buildFullForumThreadListUrl(forum),
    type: MetaType.forumThread,
  };
};

export const buildForumThreadMeta = (forumThread: ForumThreadFragment) => {
  return {
    title: forumThread.title,
    description: forumThread.title,
    url: buildFullForumThreadUrl(forumThread),
    type: MetaType.forumThreadItem,
  };
};

export enum MetaType {
  auctionItem = 'auction.item',
  productItem = 'product.item',
  forumThread = 'forum.thread',
  forumThreadItem = 'forum.thread.item',
}
